<template>
    <div>
        Contact Us
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    }
}

</script>



// WEBPACK FOOTER //
// src/views/portfolio/Content/Contact.vue